import { useGetMe } from "@entities/Onboarding/lib/hooks/useGetMe";
import { ToastService } from "@shared/lib/services";
import { BackednResponse } from "@shared/lib/types";
import { IBriefNotification } from "@shared/lib/types/brief";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { BRIEF_NOTIFICATIONS_QUERY_KEY } from "../../constants";
import { BriefService } from "../../services/brief.service";

export default function useGetNotifications(
  briefId: string,
  userId: string,
  type: "priceReachout" | "campaignExecution" | "brief"
) {
  const { userDetails } = useGetMe();
  const superUserId = userDetails?.userEntity?.id;
  const {
    data: notifications,
    isFetching: isNotificationsFetching,
    error: notificationsError,
    isError,
  } = useQuery<BackednResponse<{ data: IBriefNotification[] }>>({
    queryKey: [...BRIEF_NOTIFICATIONS_QUERY_KEY(briefId), userId, type],
    queryFn: () =>
      BriefService.getBriefNotifications(
        briefId,
        userId || "",
        superUserId || "",
        type
      ),
    enabled: !!briefId,
  });

  const errorMessage = isError && notificationsError?.message;
  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    notifications: notifications?.data?.data || [],
    isFetching: isNotificationsFetching,
    isError: notificationsError,
  };
}
